import { BaseConfig } from '../ServiceConfig';

export interface PolicyConfiguration extends BaseConfig {
  '@type': 'type.googleapis.com/terra.v1.PolicyServiceConfigData';
  url: string;
  terminal: string;
  publicSettingUrl: string;
}

export const PolicyConfigurationFields: (keyof PolicyConfiguration)[] = [
  'url',
  'terminal',
  'publicSettingUrl',
];

export const BlankPolicyConfiguration: PolicyConfiguration = {
  '@type': 'type.googleapis.com/terra.v1.PolicyServiceConfigData',
} as PolicyConfiguration;
